import { selector, atom } from "recoil";
import { getFeature, getPayPage } from "../services/apiCalls";

export const featureRefresh = atom({
  key: "featureRefresh",
  default: ""
})

export const payRefresh = atom({
  key: "payRefresh",
  default: ""
})

export const featureAlert = atom({
  key: "featureAlert",
  default: false
})

export const featureResponse = atom({
  key: "featureResponse",
  default: {}
})

export const features = selector({
  key: "features",
  get: async ({ get }) => {
    try {
      const res = get(featureRefresh);
      console.log(res)
      const result = await getFeature();
      return result.data || [];
    } catch (error) {
      console.error(`ERROR: \n${error}`);
      return [];
    }
  }
});

export const payPage = selector({
  key: "payPage",
  get: async ({ get }) => {
    try {
      const res = get(payRefresh);
      console.log(res)
      const result = await getPayPage();
      return result || {};
    } catch (error) {
      console.error(`ERROR: \n${error}`);
      return {};
    }
  }
});